import { get, patch, destroy, post } from './httpClient'

export const getVouchers = (query) => get('/order-voucher', query)
export const addVoucher = (body) => post('/order-voucher/create', body)
export const updateVoucher = (id, data) => patch(`/order-voucher/update/${id}`, data)
export const deleteVoucher = (ids) => destroy('/order-voucher/delete', { order_id: ids })
